module.exports = __webpack_public_path__ + "4e16297291336682bc8bbed3e8901d71.svg";